export default __webpack_public_path__ + "assets/images/artem-color-icons.png";